import React, { useEffect } from "react";
import Input from "../UserDashboard/Input";
import SideBar from "./SideBar";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { changePasswordSchema } from "../UserDashboard/Validation";
import toast from "react-hot-toast";
import userApi from "../../api/user/user.api";
import ProcessingBar from "../../Util/Processingbar";

function Password() {
  // validate user
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(changePasswordSchema),
  });

  const [loading, setLoading] = React.useState(false);

  const handlerSubmit = async (data) => {
    setLoading(true);

    const { response, err } = await userApi.passwordUpdate({
      password: data.oldPassword,
      newPassword: data.newPassword,
      confirmNewPassword: data.confirmPassword,
    });

    setLoading(false);

    if (err) {
      toast.error(err.message || "Password update failed");
      return;
    }

    toast.success("Password updated successfully!");

    // Clear fields
    setValue("oldPassword", "");
    setValue("newPassword", "");
    setValue("confirmPassword", "");
  };

  return (
    <SideBar>
      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-bold">Change Password</h2>

        <Input
          type="password"
          placeHolder="*******"
          label="Previous Password"
          register={register("oldPassword")}
          errors={errors.oldPassword}
          name={"oldPassword"}
        />
        <Input
          type="password"
          placeHolder="********"
          label="New Password"
          register={register("newPassword")}
          errors={errors.newPassword}
          name={"newPassword"}
        />
        <Input
          type="password"
          placeHolder="********"
          label="Confirm Password"
          register={register("confirmPassword")}
          errors={errors.confirmPassword}
          name={"confirmPassword"}
        />

        <div className="flex justify-end items-center my-4">
          <button
            disabled={loading}
            onClick={handleSubmit(handlerSubmit)}
            className={`${
              loading ? "opacity-60 cursor-not-allowed" : ""
            } bg-yellowlight text-yellowdark sm:w-auto w-full font-semibold py-3 px-6 rounded`}
          >
            {loading ? <ProcessingBar /> : "Change Password"}
          </button>
        </div>
      </div>
    </SideBar>
  );
}

export default Password;
